import Axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { httpDelete, httpGet, httpPost, httpPut } from 'src/axios/axiosUtils';
import { AccountType } from 'src/pages/Auth/helpers/tokens';
import { notifyError, notifySuccess } from 'src/utils/toast';
import useAuth from '../useAuth';

export interface CompanyInfo {
  name: string;
  jobTitle: string;
  logo: string;
  website: string;
  iosURL: string;
  playStoreURL: string;
  fbURL: string;
  igURL: string;
  linkedinURL: string;
  twitterURL: string;
  acceleratorId: number;
  companyId?: any;
  title?: any;
}

export const useSettingsComapny = () => {
  const [data, setData] = useState<CompanyInfo>();
  const { user } = useAuth();

  const [isLoading, setLoading] = useState(true);

  const fetchSettings = async () => {
    try {
      const res = await httpGet(
        user.accountType === AccountType.Accelerator
          ? '/accelerator/settings'
          : '/company/settings'
      );

      setData(res);
    } catch (error) {
      console.log('er', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user.accountType !== AccountType.Investor) {
      fetchSettings();
    }
  }, []);
  return {
    settings: data,
    isLoading: isLoading
  };
};

export interface AcceleratorDto {
  acceleratorId: number;
  name: string;
  title: string;
  createdAt: string;
}
export const useAccelerator = () => {
  const [data, setData] = useState<AcceleratorDto[]>([]);
  const { user } = useAuth();
  const [isLoading, setLoading] = useState(
    user.accountType == AccountType.Startup ? true : false
  );

  const fetchSettings = async () => {
    try {
      const res = await httpGet('/accelerator');
      console.log('res', res);

      setData(res);
    } catch (error) {
      console.log('er', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user.accountType == AccountType.Startup) {
      fetchSettings();
    }
  }, []);
  return {
    accelerators: data,
    isLoading: isLoading
  };
};

export const useSettingsUpdateComapny = () => {
  const [isLoading, setLoading] = useState(false);
  const [isLoadingUpload, setLoadingUpload] = useState(false);
  const { user } = useAuth();

  const uploadToAws = async (res, data) => {
    try {
      await Axios.put(res.uploadUrl, data, {
        headers: {
          'Content-Type': 'image/jpeg'
        }
      });

      return res;
    } catch (error) {
    } finally {
      setLoadingUpload(false);
    }
  };
  const uplaod = async (data) => {
    try {
      setLoadingUpload(true);
      const res = await httpGet('/et-file-manager/upload-url?domain=COMPANY');

      return await uploadToAws(res, data);
    } catch (error) {
      setLoadingUpload(false);
    } finally {
      setLoading(false);
    }
  };
  const updateSettings = async (data) => {
    setLoading(true);
    try {
      const res = await httpPut(
        user.accountType === AccountType.Accelerator
          ? '/accelerator/settings'
          : '/company/settings',
        data
      );

      notifySuccess('Updated Successfully');

      return res;
    } catch (error) {
      notifyError('Try Again');
    } finally {
      setLoading(false);
    }
  };

  return {
    isLoading: isLoading,
    updateSettings: updateSettings,
    uplaod: uplaod,
    isLoadingUpload: isLoadingUpload
  };
};

export interface PersonalInfo {
  firstName: string;
  email: string;
  lastName: string;
}
export const useSettingsUpdatePersonal = () => {
  const [isLoading, setLoading] = useState(true);
  const [isLoadingUpdate, setLoadingUpdate] = useState(false);
  const [isLoadingUpdateDelete, setLoadingUpdateDelete] = useState(false);

  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const updateSettingsPersonal = async (data) => {
    setLoadingUpdate(true);
    try {
      const res = await httpPut('/users/me', data);

      notifySuccess('Updated Successfully');
      return res;
    } catch (error) {
      console.log('error', error);

      notifyError(error?.message ?? 'Try Again');

      // eslint-disable-next-line @typescript-eslint/no-throw-literal
      throw {
        isError: error?.message
      };
    } finally {
      setLoadingUpdate(false);
    }
  };
  const deleteAccount = async () => {
    setLoadingUpdateDelete(true);
    try {
      const res = await httpDelete('/users/me');

      logout();
      navigate('/');
    } catch (error) {
      notifyError(error?.message ?? 'Try Again');
    } finally {
      setLoadingUpdateDelete(false);
    }
  };

  const [data, setData] = useState<PersonalInfo>();

  const fetchSettings = async () => {
    try {
      const res = await httpGet('/users/me');

      setData(res);
    } catch (error) {
      console.log('er', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (user?.userId) fetchSettings();
  }, [user?.userId]);
  return {
    isLoading: isLoading,
    updateSettings: updateSettingsPersonal,
    personal: data,
    isLoadingUpdate: isLoadingUpdate,
    deleteAccount: deleteAccount,
    isLoadingUpdateDelete: isLoadingUpdateDelete
  };
};

export const useUserSettings = () => {
  const [data, setData] = useState<PersonalInfo>();
  const [isLoading, setLoading] = useState(false);
  const {} = useAuth();

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const res = await httpGet('/users/me');

      setData(res);
    } catch (error) {
      console.log('err', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSettings();
  }, []);

  return {
    isLoading: isLoading,
    data: data
  };
};
